import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AutomotiveAftermarketProfileFilterModel } from '../../automotive-aftermarket/models';
import { PlannerProfileType } from '../../../../constants/planner-profile.constant';
import { ProfileSubscription, ProfileSubscriptionForm } from '../../../../models';
import {
  AutomotiveAftermarketProfileReport,
  AutomotiveAftermarketProfileReportForm,
} from './automotive-aftermarket-report.model';

export class AutomotiveAftermarketProfileDetails {
  id?: number;
  createdBy?: number;
  createdByEmail?: string;
  name: string;
  description: string;
  type: PlannerProfileType = PlannerProfileType.Public;
  subscription: Partial<ProfileSubscription> = new ProfileSubscription();
  report: Partial<AutomotiveAftermarketProfileReport> = new AutomotiveAftermarketProfileReport();

  constructor(params?: Partial<AutomotiveAftermarketProfileDetails>) {
    if (params) {
      Object.assign(this, params);
      if (!params.subscription) {
        this.subscription = new ProfileSubscription();
      }
    }
  }
}

export class AutomotiveAftermarketProfileModel extends AutomotiveAftermarketProfileDetails {
  filter: AutomotiveAftermarketProfileFilterModel = new AutomotiveAftermarketProfileFilterModel();

  constructor(params?: AutomotiveAftermarketProfileModel) {
    super();
    if (params) {
      Object.assign(this, params);
      this.filter = new AutomotiveAftermarketProfileFilterModel(params.filter);
    }
  }
}

export class AutomotiveAftermarketProfileDetailsForm {
  id?: FormControl<number>;
  createdBy?: FormControl<number>;
  createdByEmail?: FormControl<string>;
  constructor(
    model: AutomotiveAftermarketProfileDetails,
    fb: FormBuilder = new FormBuilder(),
    public name: FormControl<string> = fb.control<string>(model.name, [Validators.required]),
    public description: FormControl<string> = fb.control<string>(model.description, []),
    public type: FormControl<PlannerProfileType> = fb.control<PlannerProfileType>(model.type, [
      model.type ? Validators.required : null,
    ]),
    public subscription: FormGroup<ProfileSubscriptionForm> = fb.group<ProfileSubscriptionForm>(
      new ProfileSubscriptionForm(model.subscription),
    ),
    public report: FormGroup<AutomotiveAftermarketProfileReportForm> = fb.group<AutomotiveAftermarketProfileReportForm>(
      new AutomotiveAftermarketProfileReportForm(model.report),
    ),
  ) {
    if (model.id) {
      this.id = fb.control<number>(model.id, []);
    }
    if (model.createdBy) {
      this.createdBy = fb.control<number>(model.createdBy, []);
    }
    if (model.createdByEmail) {
      this.createdByEmail = fb.control<string>(model.createdByEmail, []);
    }
  }
}
